import {Observable} from 'rxjs';
import {createAction} from 'redux-actions';

import {combineEpics} from 'web-app/util/redux-observable';
import * as GlobalEventActions from 'web-app/react/global-event/actions';

import actionTypes from './action-types';
import Api from './api';

export const fetchRecipientsObservable = (type, extraData, successData) => {
    if (!Api[type] || !Api[type].getPossibleRecipients) {
        return Observable.of(GlobalEventActions.updateError.action(`Recipient type "${type}" not defined.`));
    }

    return Api[type]
        .getPossibleRecipients(extraData)
        .map(recipients => createAction(actionTypes.RECIPIENTS_FETCH_SUCCESS)({type, recipients, successData}));
};

const fetchRecipients = action$ =>
    action$.ofType(actionTypes.RECIPIENTS_FETCH).mergeMap(({payload}) => {
        const {type, extraData, successData} = payload;

        return fetchRecipientsObservable(type, extraData, successData).catch(e =>
            Observable.of(createAction(actionTypes.RECIPIENTS_FETCH_FAILED)({type, message: e.message})),
        );
    });

export const fetchSendersObservable = (type, context) => {
    if (!Api[type] || !Api[type].getPossibleSenders) {
        return Observable.of(GlobalEventActions.updateError.action(`Recipient type "${type}" not defined.`));
    }

    return Api[type]
        .getPossibleSenders(context)
        .map(senders => createAction(actionTypes.RECIPIENTS_SENDERS_FETCH_SUCCESS)({type, senders}));
};

const fetchSenders = action$ =>
    action$.ofType(actionTypes.RECIPIENTS_SENDERS_FETCH).mergeMap(({payload}) => {
        const {type, context} = payload;

        return fetchSendersObservable(type, context).catch(e =>
            Observable.of(createAction(actionTypes.RECIPIENTS_SENDERS_FETCH_FAILED)({type, message: e.message})),
        );
    });

export default combineEpics(fetchRecipients, fetchSenders);
